import { useLayoutEffect } from 'react';
import { useAppContainerContext } from './AppContainerContext';

type Props = {
  children: React.ReactNode;
};

export function SidebarContent({ children }: Props) {
  const { setSidebarContent } = useAppContainerContext();

  useLayoutEffect(() => {
    setSidebarContent(children);
    return () => {
      setSidebarContent(null);
    };
  }, [children, setSidebarContent]);

  return null;
}
